import { render, staticRenderFns } from "./Pantalla.vue?vue&type=template&id=38f763fa&"
import script from "./Pantalla.vue?vue&type=script&lang=ts&"
export * from "./Pantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38f763fa', component.options)
    } else {
      api.reload('38f763fa', component.options)
    }
    module.hot.accept("./Pantalla.vue?vue&type=template&id=38f763fa&", function () {
      api.rerender('38f763fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/FugaCombustible/Pantalla.vue"
export default component.exports